import React from 'react';
import ShowPackageCustomCategoryWeightRangeCostsButtonProperties from "./ShowPackageCustomCategoryWeightRangeCostsButtonProperties";
import ShowPackageCustomCategoryWeightRangeCostsStore from "./ShowPackageCustomCategoryWeightRangeCostsStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./ShowPackageCustomCategoryWeightRangeCostsButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { useUserContext } from '../../../contexts/UserContext';
import { PackageDeliveryType } from '../../../model/packageDelivery/PackageDeliveryType';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import AddAlarmIcon from '@mui/icons-material/AddAlarm';
import ShowPackageCustomCategoryWeightRangeCostsButtonRow from './ShowPackageCustomCategoryWeightRangeCostsButtonRow/ShowPackageCustomCategoryWeightRangeCostsButtonRow';

const ShowPackageCustomCategoryWeightRangeCostsButton: React.FC<ShowPackageCustomCategoryWeightRangeCostsButtonProperties> = ({
                                                                  onClick = () => {
                                                                  },
                                                                  onSave = () => {
                                                                  },
                                                                  showIcon = true,
                                                                  showText = true,
                                                                  disabled,
                                                                  className = '',
                                                                  rounded = false,
                                                                  size = ButtonSize.DEFAULT,
                                                                  type = ButtonType.DEFAULT
                                                              }) => {
    const classes = useStyles(showText);
    const commonContext = useCommonContext();
    const store = new ShowPackageCustomCategoryWeightRangeCostsStore(commonContext);
    const userStore = useUserContext();

    if (userStore.isRootAgency()) {
        return <div></div>;
    }

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const getDeliveryTypeIcon = (deliveryType: string) => {
        switch (deliveryType) {
            case PackageDeliveryType[PackageDeliveryType.PLANE]:
                return <AirplanemodeActiveIcon></AirplanemodeActiveIcon>;
            case PackageDeliveryType[PackageDeliveryType.SHIP]:
                return <DirectionsBoatIcon></DirectionsBoatIcon>;
            case PackageDeliveryType[PackageDeliveryType.EXPRESS]:
                return <AccessAlarmsIcon></AccessAlarmsIcon>;
            case PackageDeliveryType[PackageDeliveryType.SEMI_EXPRESS]:
                return <AddAlarmIcon></AddAlarmIcon>;
            default:
                return <></>;
        }
    }

    const getDeliveryTypeText = (deliveryType: string) => {
        switch (deliveryType) {
            case PackageDeliveryType[PackageDeliveryType.PLANE]:
                return 'Avión';
            case PackageDeliveryType[PackageDeliveryType.SHIP]:
                return 'Barco';
            case PackageDeliveryType[PackageDeliveryType.EXPRESS]:
                return 'Express';
            case PackageDeliveryType[PackageDeliveryType.SEMI_EXPRESS]:
                return 'Semi Express';
            default:
                return <></>
        }
    }

    const text = "Precios de costo";
    const btnIcon = <AttachMoneyIcon />;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text} onClose={onCloseModal} open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <div className={classes.package_sale_prices_table}>
                            {
                                store.customCategories.map((customCategory, i) => (
                                    <div className={classes.category_container} key={customCategory.id}>
                                        <div className={classes.category_header}>
                                            <div className={classes.category_name}>{customCategory.name}</div>
                                        </div>
                                        <div className={classes.elements_container}>
                                            {Object.keys(PackageDeliveryType)
                                                .filter((key) => isNaN(Number(key))).map((deliveryType, i) => (
                                                <div>
                                                    <div className={classes.delivery_type_header}>
                                                        <div>
                                                            {getDeliveryTypeIcon(deliveryType)}
                                                        </div>
                                                        <div>{getDeliveryTypeText(deliveryType)}</div>
                                                    </div>
                                                    {store.customCategoryWeinghtRangesPrices
                                                        .filter(t => 
                                                            t.customCategoryId === customCategory.id &&
                                                            t.deliveryType.toString() === deliveryType).map((weightRange, index) => (
                                                            <ShowPackageCustomCategoryWeightRangeCostsButtonRow
                                                                customCategoryWeinghtRangesPrice={weightRange} key={i}
                                                            />
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default ShowPackageCustomCategoryWeightRangeCostsButton;